@if (data) {
  @if (data.type === teaserSectionType.HEADLINE) {
    <mb-section-headline [headline]="data.headline" [anchor]="data.anchor"></mb-section-headline>
  } @else {
    @if ((data.headline || data.anchor) && !data.customHeadline) {
      <mb-section-headline
        [headline]="data.headline"
        [anchor]="data.anchor"
        [class.show]="show"
        [ngClass]="sectionHeadlineClasses"
      >
      </mb-section-headline>
    }

    @switch (data.type) {
      @case (teaserSectionType.STAGE) {
        <mb-stage-section [isMainStage]="index === 0" [items]="data.items"></mb-stage-section>
      }

      @case (teaserSectionType.ANNOUNCEMENT) {
        <mb-announcement-banner [data]="data"></mb-announcement-banner>
      }

      @case (teaserSectionType.HERO) {
        <mb-hero-section [data]="data" (openMedia)="openMedia.emit($event)"></mb-hero-section>
      }

      @case (teaserSectionType.EQUAL_3) {
        <mb-equal3-section (openMedia)="openMedia.emit($event)" [data]="data"></mb-equal3-section>
      }

      @case (teaserSectionType.EQUAL_4) {
        <mb-equal4-section [data]="data" (openMedia)="openMedia.emit($event)"></mb-equal4-section>
      }

      @case (teaserSectionType.PRESSKIT) {
        <mb-press-kit-section [pressKitSection]="data"></mb-press-kit-section>
      }

      @case (teaserSectionType.PRESS_RELEASE) {
        <mb-press-release-section [pressReleaseSection]="data"></mb-press-release-section>
      }

      @case (teaserSectionType.SQUARE) {
        <mb-square-section
          [inverted]="data.inverted"
          [data]="data"
          (openMedia)="openMedia.emit($event)"
        ></mb-square-section>
      }

      @case (teaserSectionType.INFO) {
        <mb-info-section
          [anchor]="data.anchor"
          [infoType]="data.infoType"
          [headline]="data.title"
          [text]="data.text"
          [buttonTargetType]="data.buttonTargetType"
          [buttonLabel]="data.buttonLabel"
          [buttonLink]="data.buttonLink"
          [qaForm]="data.qaForm"
        ></mb-info-section>
      }

      @case (teaserSectionType.STAGGERED) {
        <mb-staggered-section [data]="data" (openMedia)="openMedia.emit($event)"></mb-staggered-section>
      }

      @case (teaserSectionType.CONTACT) {
        <mb-contact-section [data]="data"></mb-contact-section>
      }

      @case (teaserSectionType.CAROUSEL) {
        <mb-carousel-section
          [items]="data.teasers"
          [ratio]="data.ratio"
          (openMedia)="openMedia.emit($event)"
        ></mb-carousel-section>
      }

      @case (teaserSectionType.EVENT_RIBBON) {
        <mb-event-ribbon-section></mb-event-ribbon-section>
      }

      @case (teaserSectionType.TEST_CAR) {
        <mb-test-car-section
          [sectionId]="data.id"
          [items]="data.teasers"
          [filters]="data.filters"
          [headline]="data.headline"
          [anchor]="data.anchor"
        ></mb-test-car-section>
      }

      @case (teaserSectionType.AGENDA) {
        <mb-agenda-section [agenda]="data"></mb-agenda-section>
      }

      @case (teaserSectionType.TEST_ROUTE) {
        <mb-test-route-section [data]="data"></mb-test-route-section>
      }

      @case (teaserSectionType.EVENT_REGISTRATION) {
        <mb-event-registration-section
          [eventId]="data.eventId"
          (showSection)="show = $event"
        ></mb-event-registration-section>
      }

      @case (teaserSectionType.EVENT_CONTACTS) {
        <mb-event-presenters-section
          [eventId]="data.eventId"
          (showSection)="show = $event"
          [sectionType]="teaserSectionType.EVENT_CONTACTS"
        ></mb-event-presenters-section>
      }

      @case (teaserSectionType.EVENT_EXPERTS) {
        <mb-event-presenters-section
          [eventId]="data.eventId"
          (showSection)="show = $event"
          [sectionType]="teaserSectionType.EVENT_EXPERTS"
        ></mb-event-presenters-section>
      }

      @case (teaserSectionType.HIGHLIGHT) {
        <mb-highlight-section [highlightSection]="data"></mb-highlight-section>
      }

      @case (teaserSectionType.DYNAMIC) {
        @if (data.hasContent) {
          <mb-dynamic-section
            [topicId]="data.topicId"
            [title]="data.title"
            [entities]="data.entities"
            [filterGroups]="data.filterGroups"
            [assetsCount]="data.assetsCount"
            [showSingleTabNav]="data.showSingleTabNav"
            [showShowAllButton]="data.showShowAllButton"
            [entityLabelOverrides]="data.entityLabelOverrides"
          ></mb-dynamic-section>
        }
      }
    }
  }
}
